import {Model, ModelMixin} from '../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class Malpractice extends ModelMixin() implements Model<Malpractice> {

    TYPE = Malpractice;
    static projectionInformation = new ProjectionInformation('malpractice');

    public claim: boolean;
    public claimDetails: string;
    public monetaryPayment: boolean;
    public pendingClaims: boolean;
    public insuranceDenial: boolean;
    public insuranceDenialDetails: string;
    public procedureExclusion: boolean;
    public procedureExclusionDetails: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/malpractice.model.ts